/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Payments_N_Refunds__Question_5Inputs */

const en_help_center__payments_n_refunds__question_5 = /** @type {(inputs: Help_Center__Payments_N_Refunds__Question_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my payment information secure?`)
};

/**
* | output |
* | --- |
* | "Is my payment information secure?" |
*
* @param {Help_Center__Payments_N_Refunds__Question_5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__payments_n_refunds__question_5 = /** @type {((inputs?: Help_Center__Payments_N_Refunds__Question_5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Payments_N_Refunds__Question_5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__payments_n_refunds__question_5(inputs)
});